import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { ServerRequest } from './apiweb';
import { VALIDATION_MESSAGE } from '../consts/validationMessage';
import { BUSINESS_CODE } from '../consts/businessCode';

export const createSearchWithSavedFilters = ({
    setState,
    setTableVisible,
    apiUrl,
    tabsConfig = null,
    buildParamsUrl = null,
    callbackNoSuccess,
    callbackError,
    onSuccess = null,
    setSearchMessage = null
}) => {
    return (savedFilters) => {
        let resolveSearch;
        const searchDone = new Promise((resolve) => { resolveSearch = resolve; });

        if (!savedFilters || !savedFilters.filters) {
            console.error('savedFilters or savedFilters.filters is missing');
            resolveSearch(false);
            return searchDone;
        }

        setState(prevState => ({ ...prevState, loading: true, list: [] }));
        setSearchMessage?.(null);

        const callbackSuccess = (response) => {
            response.json()
                .then((data) => {
                    setState(prevState => ({ ...prevState, loading: false, list: data }));
                    setTableVisible(true);
                    resolveSearch(true);
                    
                    if (onSuccess) {
                        onSuccess(savedFilters);
                    }
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => ({ ...prevState, loading: false }));
                    if (callbackError) {
                        callbackError(error);
                    }
                    resolveSearch(false);
                });
        };

        let paramsUrl;
        
        try {
            if (tabsConfig) {
                const activeTabKey = savedFilters.activeTab || tabsConfig[0]?.key;
                const activeTabConfig = tabsConfig.find(tab => tab.key === activeTabKey);
                
                if (!activeTabConfig) {
                    throw new Error(`Tab ${activeTabKey} not found in tabsConfig`);
                }
                paramsUrl = activeTabConfig.buildUrl(savedFilters.filters);
            } else if (buildParamsUrl) {
                paramsUrl = buildParamsUrl(savedFilters.filters);
            } else {
                throw new Error('Se requiere tabsConfig o buildParamsUrl');
            }
        } catch (error) {
            console.error('Error building URL:', error);
            setState(prevState => ({ ...prevState, loading: false }));
            if (callbackError) {
                callbackError(error);
            }
            resolveSearch(false);
            return searchDone;
        }

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            apiUrl,
            paramsUrl,
            null,
            callbackSuccess,
            (response) => {
                response.clone().json()
                    .then((error) => {
                        if (error?.businessCode === BUSINESS_CODE.MAX_QUERY_SIZE_EXCEEDED) {
                            setState(prevState => ({ ...prevState, loading: false, list: [] }));
                            setTableVisible(false);
                            setSearchMessage?.(VALIDATION_MESSAGE.TOO_MANY_RESULTS);
                            return;
                        }
                        callbackNoSuccess(response);
                    })
                    .catch(() => callbackNoSuccess(response));
                resolveSearch(false);
            },
            (error) => {
                callbackError(error);
                resolveSearch(false);
            }
        );

        return searchDone;
    };
};
